import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import {SummaryCashModel} from '../models/summary-cash.model'

@Injectable()
export class CashService extends BaseService<SummaryCashModel,SummaryCashModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/cashs');
  }

}
